export default "__VITE_ASSET__DR82FLez__"